<template>
  <div class=" about-page page-padding-top">
    <top-bar :title="i18n.t('about.title')"  @back="back"></top-bar>

    <div class="menu-list">
      <div  class="menu flex-center">
        <div class="flex-1 name">{{i18n.t('about.label1')}}</div>
        <div class="adot flex-center">
          <span>{{$t('about.label4')}}</span>
          <img :src="rightUrl" alt="">
        </div>
      </div>
      <div  class="menu flex-center" @click="toPath('privacy')">
        <div class="flex-1 name">{{i18n.t('about.label2')}}</div>
        <div class="adot">
          <img :src="rightUrl" alt="">
        </div>
      </div>
      <div  class="menu flex-center" @click="toPath('agreement')">
        <div class="flex-1 name">{{i18n.t('about.label3')}}</div>
        <div class="adot">
          <img :src="rightUrl" alt="">
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import topBar from '@/components/topBar'
export default {
  components: {
    topBar
  },
  data() {
    return {
      logoUrl: require('../../assets/imgs/logo.png'),
      rightUrl: require('../../assets/imgs/icon-arrow-right2.png'),
    }
  },
  computed: {
    appName() {
      return this.$store.state.appName
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    toPath(path) {
      if (path) {
        this.$router.push({
          name: path
        })
      }
    },
    toRefresh() {
      this.$toast.success(this.i18n.t('about.label3'))
    }
  }
}
</script>